import { ArrowBack } from '@mui/icons-material'
import { Box, Stack, Typography } from '@dtx-company/design-system/src'
import { IconButton } from '@dtx-company/design-system/src/components/IconButton/IconButton'
import { MOBILE_NAV_V3_HEIGHT } from '@dtx-company/true-common/src/constants/layout'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const PlanUpgradeMobileHeader: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation('nav')

  return (
    <Stack
      direction="row"
      sx={theme => ({
        position: 'fixed',
        top: 0,
        backgroundColor: 'background.paper',
        width: '100%',
        justifyContent: 'flex-start',
        p: theme.spacing(2, 3),
        borderWidth: theme.spacing(0, 0, 0.25, 0),
        borderColor: 'border.divider',
        borderStyle: 'solid',
        alignItems: 'center',
        height: `${MOBILE_NAV_V3_HEIGHT}px`,
        zIndex: 'appBar'
      })}
    >
      <Box sx={{ position: 'absolute' }}>
        <IconButton
          variant="text"
          icon={ArrowBack}
          onClick={onClose}
          data-testid="plan-upgrade-mobile-header-back-button"
        />
      </Box>
      <Box sx={{ width: '100%' }}>
        <Typography align="center" variant="subtitleMedium">
          {t('PlansUpgradeDialog.PlansAndPricing')}
        </Typography>
      </Box>
    </Stack>
  )
}
